import { AppBar, Avatar, Box, Toolbar, Typography } from "@mui/material";
import { Link } from "react-router-dom";
import useAuth from "../../hooks/useAuth";

const getInitials = (value = "") => {
  const parts = String(value).trim().split(/\s+/).filter(Boolean);

  if (parts.length === 0) {
    return "GP";
  }

  return parts
    .slice(0, 2)
    .map((part) => part[0])
    .join("")
    .toUpperCase();
};

const PageTopBar = () => {
  const auth = useAuth();
  const user = auth.user || {};
  const userDisplayName =
    user.name ||
    user.full_name ||
    user.email ||
    (user.developmentMode ? "Development Mode" : "User");
  const userEmail = user.email || (user.developmentMode ? "Local development" : "Signed in user");
  const userAvatarSrc = user.picture || user.avatar || user.image || user.pictureUrl || "";

  return (
    <AppBar
      position="fixed"
      color="inherit"
      elevation={1}
      sx={{
        zIndex: (theme) => theme.zIndex.drawer + 1,
        backdropFilter: "blur(12px)",
        backgroundColor: "rgba(255, 255, 255, 0.92)",
        borderBottom: "1px solid rgba(0, 0, 0, 0.08)",
      }}
    >
      <Toolbar sx={{ display: "flex", justifyContent: "space-between", gap: 2 }}>
        <Typography
          component={Link}
          to="/"
          variant="h6"
          fontWeight="700"
          noWrap
          sx={{ color: "inherit", textDecoration: "none" }}
        >
          GetProNow
        </Typography>

        <Box sx={{ display: "flex", alignItems: "center", gap: 1.5, minWidth: 0 }}>
          <Box sx={{ textAlign: "right", minWidth: 0 }}>
            <Typography variant="subtitle2" fontWeight="700" noWrap>
              {userDisplayName}
            </Typography>
            <Typography variant="caption" color="text.secondary" noWrap>
              {userEmail}
            </Typography>
          </Box>
          <Avatar src={userAvatarSrc} alt={userDisplayName} sx={{ width: 38, height: 38 }}>
            {getInitials(userDisplayName)}
          </Avatar>
        </Box>
      </Toolbar>
    </AppBar>
  );
};

export default PageTopBar;
